module.exports = __webpack_public_path__ + "media/6.2da9e1d9.mp3";